import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { Session } from "./session";

const ANONYMOUS: Session = { status: "anonymous" };

const SessionContext = createContext<Session>(ANONYMOUS);

interface SessionProviderProps {
  /**
   * Supplied by the auth integration (B01.07). Defaults to anonymous so an unconfigured
   * app can never grant access.
   */
  session?: Session;
  children: ReactNode;
}

export function SessionProvider({ session = ANONYMOUS, children }: SessionProviderProps) {
  return <SessionContext value={session}>{children}</SessionContext>;
}

export function useSession(): Session {
  return useContext(SessionContext);
}
